<template>
  <div class="availability-picker-wrap">
    <v-combobox
      v-model="prepAvailabilitySelections"
      item-text="name"
      label="Filter by Availability"
      placeholder="Type to Search"
      multiple
      deletable-chips
      small-chips
      allow-overflow
      hide-details
      open-on-clear
      outlined
      cache-items
      return-object
      clearable
      dense
      class="mb-1"
      :loading="isLoading"
      :items="availabilityOptions"
      @focus="loadItems()"
      @update:search-input="searchUpdate"
    >
      <template #item="{item}">
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle
            >{{ item.start_date }}–{{ item.end_date }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

import AvailabilityModel from '@/models/AvailabilityModel'

import { format, parseISO } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'
import _sortBy from 'lodash/sortBy'
import _reverse from 'lodash/reverse'
import _map from 'lodash/map'
import debounce from 'debounce'

export default {
  name: 'OrderPrepAvailabilityPicker',
  components: {},
  data() {
    return {
      availabilityOptions: [],
      isLoading: false,
      isUpdating: false,
      isFocused: false,
    }
  },
  computed: {
    ...mapFields('admin', ['prepAvailabilitySelections']),
  },
  mounted() {
    this.prepAvailabilitySelections = []
  },
  methods: {
    searchUpdate: debounce(function(q) {
      if (!q) return
      this.loadItems({ q })
    }, 250), // tiptapUpdate
    async loadItems(options) {
      this.availabilityOptions = []
      this.isLoading = true
      let defaults = { per_page: 100, sort: '-start_date' }
      options = { ...defaults, ...options }
      try {
        await AvailabilityModel.fetchForShop(options)
        const sortValue = 'start_time'
        this.availabilityOptions = _reverse(
          _map(_sortBy(AvailabilityModel.all(), sortValue), (availability) => {
            const start_date = format(
              parseISO(availability.start_time),
              TimeFormats.dateSlashesShortYear
            )
            const end_date = format(
              parseISO(availability.end_time),
              TimeFormats.dateSlashesShortYear
            )
            return {
              ...availability,
              start_date,
              end_date,
            }
          })
        )
      } catch (error) {
        this.error = error
      } finally {
        this.isLoading = false
      }
    }, // loadItems
  },
}
</script>
